<template>
  <Dialog
    width="860px"
    :height="createRenderType == 'mobile' ? 'unset' : '652px'"
    titleAlign="left"
    :title="$$t('editor.create_singer')"
    v-model:visible="renderData.visible"
    @close="closeDialog"
    mobileRenderType="drawerDialog"
    :customClass="`cover-voice-custom-dialog ${
      createRenderType == 'mobile' ? 'cover-voice-custom-dialog--mobile' : ''
    }`"
  >
    <div
      class="cover-voice-custom-dialog-container"
      :class="{
        [`cover-voice-custom-dialog-container--${createRenderType}`]: true,
      }"
    >
      <div class="cover-voice-custom-item-label">
        {{ $$t("editor.voice_dataset_label") }}
      </div>
      <div class="cover-voice-custom-item-content">
       <CoverSingerCustomUpload></CoverSingerCustomUpload>
      </div>
      <div class="cover-voice-custom-row flex">
        <div class="cover-voice-custom-row-item">
          <div class="cover-voice-custom-item-label">
            {{ $$t("editor.singer_name_label") }}
          </div>
          <div class="cover-voice-custom-item-content">
            <textarea
              :placeholder="$$t('editor.singer_name_placeholder')"
            ></textarea>
          </div>
        </div>
        <div class="cover-voice-custom-row-item">
          <div class="cover-voice-custom-item-label">
            {{ $$t("editor.singer_cover_label") }}
          </div>
          <div class="cover-voice-custom-item-content">
            <UploadClipImageMini
              :imageExplain="$$t('create.song_publish_image_explain')"
              ref="refUploadClipImage"
              @urlChange="onSongUrlChange"
            ></UploadClipImageMini>
          </div>
        </div>
      </div>

      <div class="cover-voice-custom-submit">
        <Button
          @click="onSubmitClick"
          :disabled="props.disabled"
          :loading="props.isLoading"
          :renderStyle="{
            '--padding': '0',
            '--width': '100%',
            '--height': '48px',
            '--borderRadius': '48px',
            '--background':
              'linear-gradient(97deg, rgba(79, 222, 255, 1) 0%, rgba(230, 117, 255, 1) 99%)',
            '--fontColor': '#000',
            '--fontSize': '16px',
            '--fontWeight': '500',
            '--border': 'none',
            '--backgroundHover':
              'linear-gradient(97deg, rgba(79, 222, 255, 0.75) 0%, rgba(230, 117, 255, 0.75) 99%)',
            '--fontColorHover': '#000',
          }"
        >
          <span class="fn-inline">{{ $$t("create.submit") }}</span>
        </Button>
      </div>

      <div class="cover-voice-custom-description tc">
        {{ $$t("editor.create_singer_description") }}
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";

import { useRouter, useRoute } from "vue-router";
import globalConfig, { chinaAppName } from "@/config/config.js";

import apiEditor from "@/api/api/apiEditor.js";

import { showActionDialog } from "@/components/functionCallComponent/action/action.js";

import AudioDragUpload from "../component/audioDragUpload.vue";
import Button from "@/components/basic/button/Button.vue";
import EditSelectAudio from "../component/editSelectAudio.vue";
import CoverLibrary from "./coverLibrary.vue";
import UploadClipImageMini from "@/components/basic/uploadClipImage/uploadClipImageMini.vue";
import CoverSingerCustomUpload from "./coverSingerCustomUpload.vue"

import tools from "@/utils/tools.js";
import ffmpegUtil from "@/components/media/utils/ffmpegUtil.js";
import message from "@/components/functionCallComponent/message.jsx";
import clipUtil from "@/components/media/utils/clipUtil.js";
import objectStorage, {
  getObjectStorageFullUrl,
} from "@/lib/objectStorage/objectStorage.js";

import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useUserDataStore from "@/store/userDataStore.js";
import useFeedListStore from "@/store/create/feedListDataStore.js";

const createLayoutStore = useCreateLayoutStore();
const userDataStore = useUserDataStore();
const { createRenderType } = storeToRefs(createLayoutStore);

const feedListDataStore = useFeedListStore();
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const Router = useRouter();
const route = useRoute();

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(["update:visible"]);

const stateData = {};

const renderData = reactive({
  visible: props.visible,
  editMode: "upload", // "upload", "processing","editing"
  linkParseUrl: "",
  file: null,
  files: [],
  linkUrl: "",
  clipSourceData: null,
  editFileName: "",
  audioUrl: "", // https://test.mureka.ai/cos-test/song/audio/20250213/music_56098979577857_PfJV1K6VMYcGNNWnzYropf_bcfiec.mp3",
  audioDuration: 160.183,
  waveformData: Array.from(
    {
      length: 1000,
    },
    (v, i) => Math.random()
  ),
  disabledSubmit: true,
});

const renderDataValid = reactive({
  validataFilename: "",
  validataSongCover: "",
});

const closeDialog = () => {
  if (renderData.editMode === "editing") {
    showActionDialog({
      content: $$t("editor.edit_close_warning"),
      cancelLabel: $$t("editor.keep"),
      confirmLabel: $$t("create.close"),
      titleAlign: "left",
      confirm: (closeAction) => {
        closeAction();
        renderData.visible = false;
      },
    });
  } else {
    renderData.visible = false;
  }
};

const doRemove = async () => {};

const onSongUrlChange = (hasUrl) => {
  if (hasUrl) {
    renderDataValid.validataSongCover = "";
  } else {
    renderDataValid.validataSongCover = $$t("create.this_field_is_required");
  }
};

const onUploadYoutubeClick = () => {

}


const handleUploadFile = (file) => {
  
}


const onSubmitClick = () => {
  feedListDataStore
    .doReginEditSongDoneReGenerate({})
    .then(() => {
      renderData.editSongDialogVisible = false;
    })
    .catch((err) => {
      callback(err);
    });
};

watch(
  () => {
    return props.visible;
  },
  () => {
    renderData.visible = props.visible;
  }
);
watch(
  () => {
    return renderData.visible;
  },
  () => {
    emits("update:visible", renderData.visible);
  }
);

onMounted(() => {});
</script>
<style lang="scss">
.cover-voice-custom-dialog {
  .content-top-margin {
    height: 20px;
  }
  &.cover-voice-custom-dialog--mobile {
    .content-top-margin {
      height: 16px;
    }
  }
}
.cover-voice-custom-dialog-container {
  padding: 0 40px;
  .cover-voice-custom-item-label {
    font-family: HarmonyOS Sans SC;
    font-size: 16px;
    font-weight: normal;
    line-height: 20px;
    color: #ffffff;
    margin: 0 0 12px 0;
  }
  .cover-voice-custom-item-content {
    margin: 0 0 20px 0;
  }
  

  .cover-voice-custom-row {
    .cover-voice-custom-row-item {
      width: 0;
      flex: 1;
      &:not(:first-child) {
        margin: 0 0 0 12px;
      }
    }
    textarea,
    input {
      width: 100%;
      padding: 14px;
      height: 80px;
      background: none;
      border: none;
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: normal;
      line-height: 24px;
      color: #ffffff;
      border-radius: 8px;

      background: rgba(255, 255, 255, 0.1);
      resize: none;
      &::placeholder {
        color: rgba(255, 255, 255, 0.5) !important;
      }
    }
  }

  .cover-voice-custom-description {
    font-family: HarmonyOS Sans SC;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.5);
    margin: 12px 0 0 0;
  }

  &.cover-voice-custom-dialog-container--mobile {
    min-height: 100%;
    padding: 0 20px;
    
    .cover-voice-custom-row {
      flex-direction: column;
      .cover-voice-custom-row-item {
        width: 100%;
        flex: unset;
        &:not(:first-child) {
          margin: 0 0 0 0;
        }
      }
      textarea {
        height: 48px;
        padding: 12px;
      }
    }
    .cover-voice-custom-description {
      margin: 12px 0 20px 0;
    }
  }
}
</style>
